// LDF: Kann diese Nummer WhatsApp haben?
// Deutsche Nummern: nur Handy (015x/016x/017x). Ausländische Nummern (+… / 00…, nicht +49):
// Festnetz und Handy lassen sich nicht sicher unterscheiden – dann WhatsApp erlauben.
export const isWhatsAppCapable = (number: string) => {
  const n = number.replace(/[\s()/.-]/g, "");
  if (/^(\+49|0049)/.test(n)) return /^(\+49|0049)1[5-7]/.test(n);
  if (/^(\+|00)[1-9]/.test(n)) return true;
  return /^01[5-7]/.test(n);
};
